"use client";

import type { ReactNode } from "react";
import { StudioActionMenu } from "@/studio/components/chrome/StudioActionMenu";
import type { StudioMenuItem } from "./types";

/** Shared menu. Desktop uses the global context menu. Mobile opens the centered sheet. */
export function StudioMenu({
  label,
  trigger,
  items,
  className,
}: {
  label: string;
  trigger: ReactNode;
  items: StudioMenuItem[];
  className?: string;
}) {
  return (
    <StudioActionMenu
      label={label}
      trigger={trigger}
      triggerClassName={className}
      items={items.map((item) => ({
        id: item.id,
        label: item.label,
        icon: item.icon,
        danger: item.danger,
        section: "actions",
        onSelect: item.onSelect,
      }))}
    />
  );
}
